import { render, staticRenderFns } from "./MenuModal.html?vue&type=template&id=450f5f74&scoped=true&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuModal.scss?vue&type=style&index=0&id=450f5f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f5f74",
  null
  
)

export default component.exports